import { FC } from 'react'
import { Outlet } from 'react-router-dom'

export const ManagedTemplates: FC = () => {
  return <Outlet />
}
